const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = 3600;

function formatDurationString(duration) {
  const { hours, minutes, seconds } = duration;
  const hourString = hours > 0 ? `${hours}h` : "";
  const minuteString = minutes > 0 ? `${minutes.toLocaleString()}m` : "";
  const secondsString = seconds > 0 ? `${seconds}s` : "0";

  return `${hourString} ${minuteString} ${secondsString}`.trim();
}

function getDurationInMinutesAndSeconds(totalSeconds) {
  const minutes = Math.floor(totalSeconds / SECONDS_IN_MINUTE);
  const seconds = totalSeconds % SECONDS_IN_MINUTE;

  const duration = {
    hours: 0,
    minutes,
    seconds,
  };

  return duration;
}

function formatDurationToMinutesAndSeconds(totalSeconds: number) {
  const durationInMinutesAndSeconds =
    getDurationInMinutesAndSeconds(totalSeconds);

  const durationString = formatDurationString(durationInMinutesAndSeconds);

  return durationString;
}

function getDurationInHoursMinutesAndSeconds(totalSeconds) {
  const hours = Math.floor(totalSeconds / SECONDS_IN_HOUR);
  const remainingSeconds = totalSeconds % SECONDS_IN_HOUR;
  const minutes = Math.floor(remainingSeconds / SECONDS_IN_MINUTE);
  const seconds = remainingSeconds % SECONDS_IN_MINUTE;

  return {
    minutes,
    hours,
    seconds,
  };
}

function formatDurationToHoursMinutesAndSeconds(totalSeconds) {
  const duration = getDurationInHoursMinutesAndSeconds(totalSeconds);

  const durationString = formatDurationString(duration);

  return durationString;
}

function formatSeconds(totalSeconds: number): string {
  const duration = { hours: 0, minutes: 0, seconds: totalSeconds };

  return formatDurationString(duration);
}

export {
  formatSeconds,
  formatDurationToMinutesAndSeconds,
  formatDurationToHoursMinutesAndSeconds,
};
